
// export default Forget;
import React, { useState } from 'react';
import axios from 'axios';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import logo from './assets/logo-footer.png';
import { useLanguage } from './store/language-context';
import { useTranslation } from 'react-i18next';

const Forget = () => {
    const { URL } = useLanguage();
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [method, setMethod] = useState('');
    const [success, setSuccess] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();
    const message = location.state?.message;

    const handleMethodChange = (e) => {
        setMethod(e.target.value);
        setEmail('');
        setPhone('');
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setSuccess('');

        if (!method) {
            return;
        }

        const contactValue = method === 'email' ? email : phone;
        const contactType = method === 'email' ? 'email' : 'phone';

        try {
            const response = await axios.post(`${URL}/send-otp`, {
                contact: contactValue,
                contact_type: contactType,
            });

            if (response.status === 200) {
                setSuccess(t('profile.pass-sent'));
                setTimeout(() => {
                    navigate('/otp-code', {
                        state: { contact: contactValue, contact_type: contactType }
                    });
                }, 2000);
            } else {
                setError(t('custom.err'));
            }
        } catch (error) {
            setError(t('profile.check-again'));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='login-section'>
            {message && <div className="alert alert-warning">{message}</div>}
            <div className="login row justify-content-between">
                <div className="right-section logoimg col-lg-7 col-md-6">
                    <Link to='/' className='image-part'>
                        <img src={logo} className='img-fluid w-100' alt="Logo" />
                    </Link>
                </div>
                <div className="form-part col-lg-5 col-md-6 mt-4">
                    <div className="forgot-password">
                        <p>{t('hello')}</p>
                        <h6>{t('profile.forget')}</h6>
                        <p style={{ color: '#333', fontSize: '20px', margin: "20px auto" }}>
                            {t('profile.get-by')}
                        </p>

                        <div className='method'>
                            <label>
                                <input type="radio" value="email" checked={method === 'email'} onChange={handleMethodChange} />
                                {t('contact.email')}
                            </label>
                            <label>
                                <input type="radio" value="phone" style={{ textAlign: 'right' }} checked={method === 'phone'} onChange={handleMethodChange} />
                                {t('contact.phone')}
                            </label>
                        </div>

                        <form onSubmit={handleSubmit}>
                            {method === 'email' && (
                                <input
                                    type="email"
                                    className='mb-2'
                                    placeholder={t('footer.enter-email')}
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            )}

                            {method === 'phone' && (
                                <input
                                    type="tel"
                                    className='mb-2 !text-start'
                                    placeholder={t('footer.enter-phone')}
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                />
                            )}

                            {method && <button type="submit" disabled={loading}>
                                {loading ? t('custom.sending') : t('custom.send')}
                            </button>}
                        </form>

                        {error && <p className="error">{error}</p>}
                        {success && <p className="success">{success}</p>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Forget;
